import React, { Fragment } from 'react';
import Modal from 'react-modal';
import Sticky from 'react-stickynode';
import { Helmet } from 'react-helmet';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Header from './Header';
import Hero from './Hero';
import MainIndustries from './MainIndustries';
import Footer from './Footer';
import Toast from './Toast';
import { slugify } from '../helpers';
import * as actionCreators from '../actions/actionCreators';

class Industry extends React.Component {
  constructor(props) {
    super(props);

    // Give sectors parent name & ID, push sectors to props
    for (let data = this.props.industries, i = 0, l = data.length; i < l; i++) {
      const indus = data[i].id;
      const indusName = data[i].name;
      const squares = [];
      data[i].sectors.forEach(sectors => {
        sectors.parent = indus;
        sectors.parentName = indusName;
        squares.push(sectors.id);
      });
      data[i].squares = squares;
    }

    // Give industries an array of sector IDs for hook
    this.sects = this.props.industries
      .map((indus, i) => indus.sectors)
      .reduce((prev, curr) => prev.concat(curr), []);

    // Find sector ID based on slug, fill plate with appetites for sector
    this.slug = this.props.match.params.sectorId.toString().toLowerCase();
    this.sector = this.sects.find(sector => {
      const san = slugify(sector.name);
      // If current slug = found sector's slug
      if (san === this.slug) {
        this.appSectorId = sector.id;
        this.appSector = sector.name;
        this.parent = sector.parentName;
        const i = this.props.appetites.filter(appetite => appetite.sectorId === this.appSectorId);
        const appetite = this.props.appetites[i];
        this.plate = i;
      }
    });

    this.state = {
      isGuideOpen: false,
      isFilterOpen: false,
      isAppetiteAccordionOpen: false,
      isResourcesAccordionOpen: false,
      width: window.innerWidth,
      isInterior: true,
    };

    this.toggleGuide = this.toggleGuide.bind(this);
    this.toggleFilter = this.toggleFilter.bind(this);
    this.toggleAppetiteAccordion = this.toggleAppetiteAccordion.bind(this);
    this.toggleResourcesAccordion = this.toggleResourcesAccordion.bind(this);
  }

  // Open User Guide/add blur
  toggleGuide() {
    this.setState({
      isGuideOpen: !this.state.isGuideOpen,
    });
  }

  toggleFilter() {
    this.setState({
      isFilterOpen: !this.state.isFilterOpen,
    });
  }

  toggleAppetiteAccordion() {
    this.setState({
      isAppetiteAccordionOpen: !this.state.isAppetiteAccordionOpen,
    });
  }

  toggleResourcesAccordion() {
    this.setState({
      isResourcesAccordionOpen: !this.state.isResourcesAccordionOpen,
    });
  }

  componentWillMount() {
    window.addEventListener('resize', this.handleWindowSizeChange);
  }

  componentDidMount() {
    const tmp = this;
    setTimeout(() => {
      tmp.loadData();
    }, 2000);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange);
  }

  handleWindowSizeChange = () => {
    this.setState({ width: window.innerWidth });
  };

  loadData() {
    // Give sectors parent name & ID, push sectors to props
    for (let data = this.props.industries, i = 0, l = data.length; i < l; i++) {
      const indus = data[i].id;
      const indusName = data[i].name;
      const squares = [];
      data[i].sectors.forEach(sectors => {
        sectors.parent = indus;
        sectors.parentName = indusName;
        squares.push(sectors.id);
      });
      data[i].squares = squares;
    }

    // Give industries an array of sector IDs for hook
    this.sects = this.props.industries
      .map((indus, i) => indus.sectors)
      .reduce((prev, curr) => prev.concat(curr), []);

    // Find sector ID based on slug, fill plate with appetites for sector
    this.slug = this.props.match.params.sectorId.toString().toLowerCase();
    this.sector = this.sects.find(sector => {
      const san = slugify(sector.name);
      // If current slug = found sector's slug
      if (san === this.slug) {
        this.appSectorId = sector.id;
        this.appSector = sector.name;
        this.parent = sector.parentName;
        const i = this.props.appetites.filter(appetite => appetite.sectorId === this.appSectorId);
        const appetite = this.props.appetites[i];
        this.plate = i;
      }
    });
    this.setState({
      sector: this.appSector,
    });
  }

  render() {
    const isMobile = width <= 768;
    const { width, isInterior, isAppetiteAccordionOpen, isResourcesAccordionOpen } = this.state || {};
    const {
      toggleGuide,
      toggleFilter,
      toast,
      isGuideOpen,
      isFilterOpen,
      closeModal,
      modalIsOpen,
      bookmarkPage,
      showInstallBanner,
    } = this.props;

    return (
      <Fragment>
        <Helmet>
          <title>{`Chubb CI - ${this.parent}: ${this.appSector}`}</title>
          <meta property="og:title" content={`Chubb CI - ${this.parent}: ${this.appSector}`} />
          <meta property="og:url" content={window.location} />
          <meta name="twitter:title" content={`Chubb CI - ${this.parent}: ${this.appSector}`} />
          <meta name="twitter:url" content={window.location} />
          <link rel="canonical" href={window.location} />
        </Helmet>
        <Sticky enabled top={0} offset={100}>
          <Header
            toggleGuide={toggleGuide}
            isGuideOpen={isGuideOpen}
            closeModal={closeModal}
            modalIsOpen={modalIsOpen}
            guide="User Guide"
            bookmarkPage={bookmarkPage}
          />
          <Hero
            {...this.props}
            heading={this.appSector}
            subhead={this.parent}
            isInterior={isInterior}
          />
        </Sticky>
        <MainIndustries
          {...this.props}
          isGuideOpen={isGuideOpen}
          isFilterOpen={isFilterOpen}
          isAppetiteAccordionOpen={isAppetiteAccordionOpen}
          isResourcesAccordionOpen={isResourcesAccordionOpen}
          toggleAppetiteAccordion={this.toggleAppetiteAccordion}
          toggleResourcesAccordion={this.toggleResourcesAccordion}
          toggleFilter={toggleFilter}
          sector={this.appSectorId}
          sects={this.sects}
          plate={this.plate}
          links={this.links}
        />
        <Footer feedback="Feedback" />
        {showInstallBanner && <Toast toast={toast} />}
      </Fragment>
    );
  }
}

export default Industry;



// WEBPACK FOOTER //
// ./src/components/Industry.js